import { useState } from 'react'

import { faqColumns } from '../content'
import { Icon } from './Icon'

export function Faq() {
  const [openId, setOpenId] = useState<string | null>('initial-discussion')

  return (
    <section className="section" id="faqs" aria-labelledby="faq-title">
      <div className="container">
        <div className="faq-head reveal">
          <div>
            <p className="section-number">08 / Frequently asked</p>
            <h2 className="section-title" id="faq-title">
              Good questions. Straight answers.
            </h2>
          </div>
          <p className="section-copy">
            The model is straightforward by design. Here is what prospective
            clients usually want to know first.
          </p>
        </div>
        <div className="faq-grid reveal">
          {faqColumns.map((column, columnIndex) => (
            <div className="faq-col" key={`faq-column-${columnIndex + 1}`}>
              {column.map((faq) => {
                const isOpen = openId === faq.id
                const answerId = `faq-answer-${faq.id}`
                return (
                  <article
                    className={`faq-item${isOpen ? ' is-open' : ''}`}
                    key={faq.id}
                  >
                    <button
                      className="faq-question"
                      type="button"
                      aria-expanded={isOpen}
                      aria-controls={answerId}
                      onClick={() => setOpenId(isOpen ? null : faq.id)}
                    >
                      <span className="faq-symbol">{isOpen ? '−' : '+'}</span>
                      <span>{faq.question}</span>
                      <Icon className="faq-chevron" name="chevron" />
                    </button>
                    <div className="faq-answer" id={answerId} aria-hidden={!isOpen}>
                      <div>
                        <p>{faq.answer}</p>
                      </div>
                    </div>
                  </article>
                )
              })}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
